import { useEffect } from 'react';
import { useAddress } from '../contexts/AddressContext';
import { getCategories } from '../api/categoryService';
import { getCurations } from '../api/curationService';
import { getPromotionCode } from '../api/promotionService';
import { getCurrentLanguage } from '../config/languageConfig';
import { DEFAULT_COORDINATES } from '../config/constants';
import { getPromotionUserId } from '../utils/promotionUserIdUtils';

/**
 * 온보딩 중 백그라운드에서 홈페이지 데이터를 미리 로드하는 Hook
 * UI/UX에 영향 없이 데이터만 캐시에 저장하여 온보딩 완료 후 즉시 표시 가능
 */
export const useHomeDataPreloader = () => {
  const { address } = useAddress();

  useEffect(() => {
    const preloadHomeData = async () => {
      const hasSeenOnboarding = localStorage.getItem('hasSeenOnboarding');
      
      // 온보딩을 완료한 사용자는 프리로딩 불필요
      if (hasSeenOnboarding) {
        return;
      }

      try {
        console.log('🏠 홈페이지 데이터 백그라운드 프리로딩 시작');

        // 현재 언어 및 좌표 정보 준비
        const currentLang = getCurrentLanguage();
        const promotionUserId = getPromotionUserId();
        const coordinates = {
          lat: address?.lat ?? DEFAULT_COORDINATES.lat,
          lng: address?.lng ?? DEFAULT_COORDINATES.lng
        };

        // 병렬로 데이터 프리로딩 (UI에 영향 없음)
        const preloadPromises = [
          // 카테고리 데이터 프리로딩
          getCategories().catch(error => {
            console.warn('카테고리 프리로딩 실패:', error);
            return [];
          }),
          
          // 큐레이션 데이터 프리로딩
          getCurations(coordinates.lat, coordinates.lng).catch(error => {
            console.warn('큐레이션 프리로딩 실패:', error);
            return null;
          }),
          
          // 프로모션 데이터 프리로딩 (addressId가 있을 때만)
          address?.addressId ? 
            getPromotionCode(currentLang, address.addressId, promotionUserId).catch(error => {
              console.warn('프로모션 프리로딩 실패:', error);
              return null;
            }) : 
            Promise.resolve(null)
        ];

        await Promise.allSettled(preloadPromises);
        
        console.log('✅ 홈페이지 데이터 프리로딩 완료');
      } catch (error) {
        console.warn('홈페이지 데이터 프리로딩 중 오류:', error);
      }
    };

    preloadHomeData();
  }, [address]); // address 변경 시에만 재실행
}; 